var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['search-result-loading', !_setup.isPC && 'search-result-loading-h5']},[_c(_setup.Loading,{attrs:{"width":"40px","height":"40px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }